import React, { FC } from 'react';
import { Alert, Col, Row, Typography } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import WizardContent from '~/layouts/WizardContent';
import features from '~/constants/features';
import LeftLayout from '~/layouts/LeftLayout';
import BottomLeftActions from '~/layouts/BottomLeftActions';
import { isMerchant } from '~/utils/getDecodedJwt';
import { Button } from '~/components';
import { useGetApplication, useSalesforceErrorReturnToFillApplication } from '~/controllers/wizard';

const SalesforceError: FC = () => {
  const applicationQuery: any = useGetApplication();
  const { t } = useTranslation('stageResult');
  const returnToFillApplicationMutation = useSalesforceErrorReturnToFillApplication();
  const isSalesforceErrorExist = applicationQuery?.errorInformation?.errorMessages;
  const isCode100 = applicationQuery?.errorInformation?.errorMessage === '001';

  return (
    <WizardContent
      left={
        <LeftLayout>
          <BottomLeftActions contactUsUrl={features.contactUsLinkSalesforceError} />
        </LeftLayout>
      }
      content={
        <Container className="SalesforceError">
          <Typography.Title>{t('Application submission error')}</Typography.Title>
          <Typography.Paragraph>
            {isMerchant() ? (
              <>
                <p>
                  <Trans
                    t={t}
                    i18nKey="There is a problem with application data, please <1>contact us</1> to solve it."
                  >
                    {'There is a problem with application data, please '}
                    <a href={features.contactUsLinkSalesforceError} target="__blank">
                      contact us
                    </a>
                    {' to solve it.'}
                  </Trans>
                </p>
              </>
            ) : (
              <p>{t('There is a problem with application data.')}</p>
            )}
          </Typography.Paragraph>
        </Container>
      }
      right={
        <>
          <Row>
            <Col>
              {isCode100 &&
                isSalesforceErrorExist?.length > 0 &&
                isSalesforceErrorExist?.map((item: any) => {
                  return (
                    <Alert
                      style={{ marginBottom: 15 }}
                      key={item}
                      description={<div style={{ width: '100%' }}> {item}</div>}
                      type="error"
                    />
                  );
                })}

              <Button
                id="salesforceError_tryAgainButton"
                type="primary"
                loading={returnToFillApplicationMutation.isLoading}
                onClick={() => returnToFillApplicationMutation.mutate()}
                style={{ whiteSpace: 'break-spaces', height: 'auto' }}
              >
                {t('Go back to change the application data')}
              </Button>
            </Col>
          </Row>
        </>
      }
    />
  );
};

const Container = styled.div`
  .SalesforceError-Img {
    margin-top: 36px;
    border-radius: 14px;
    width: 100%;
  }
`;

export default SalesforceError;
